import React from "react";

function SortedBusinessList({ businessList, offerings }) {
    let businessesSorted = [];

    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "BBC")
            businessesSorted.push({
                Key: item.id,
                Display: item.id + "-" + item.Name,
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }

    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "Engineer")
            businessesSorted.push({
                Key: item.id,
                Display: item.id + "-" + item.Name,
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }

    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && (!item.Type || (item.Type !== "Engineer" && item.Type !== "BBC")))
            businessesSorted.push({
                Key: item.id,
                Display: item.id + "-" + item.Name,
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }

    for (var item of businessList) {
        if (item.Status === "ARCHIVED")
            businessesSorted.push({
                Key: item.id,
                Display: (
                    <span style={{ color: "red" }}>
                        <em>{item.id + "-" + item.Name}</em>
                    </span>
                ),
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }

    return businessesSorted;
}

export function GetStateFromPOA({ offerings, poa }) {
    if (poa == null) return "";
    return offerings?.[window.brand]?.["Regions"]?.[poa]?.["region"]?.["state"] ?? "";
}

export default SortedBusinessList;
